export const ORDERS_TYPE_ALL = 'all';
export const ORDERS_TYPE_FAVORITE = 'favorite';
export const ORDERS_TYPE_RESERVED = 'reserved';
